import React from 'react';
import 'style/block/header.css';
function Header(){
    return(
    <div className="header">
    	<header>
    		<h1 className="logo-header">GenTwo</h1>
    	</header>
    </div>
    );
}

export default Header;